// extracted by mini-css-extract-plugin
export default {"photoRoom":"SaleImmovable_photoRoom__e2dvE","pos":"SaleImmovable_pos__7lxgu"};